<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Profissional
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <h2 class="mt-7"><v-icon>mdi-account</v-icon> Dados Pessoais</h2>
            <v-row class="d-flex justify-center align-center mt-2">
              <v-btn
                x-small
                :class="$isUserAdmin() ? 'btn-image admin' : 'btn-image'"
                :color="content.foto ? 'danger' : 'primary'"
                @click="onButtonClick">
                <v-icon small>{{ content.foto ? 'mdi-trash-can' : 'mdi-attachment' }}</v-icon>{{ content.foto ? "Excluir Foto" : "Anexar Foto" }}
              </v-btn>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept=".jpg, .jpeg, .png"
                @change="onFileChanged"
              />
              <v-col cols="3">
                <div class="d-flex flex-column pb-5">
                  <v-img
                    :src="imgURL"
                    width="9em"
                    height="9em"
                    class="img"
                  ></v-img>
                </div>
              </v-col>
              <v-col cols="9">
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      v-model="content.nome"
                      label="Nome*"
                      maxlength="100"
                      counter="100"
                      outlined
                      dense
                      :readonly="edit"
                      :rules="[(v) => $required(v), (v) => $max(v, 100)]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="content.cpf"
                      v-mask="'###.###.###-##'"
                      label="CPF*"
                      maxlength="14"
                      outlined
                      dense
                      v-only-number
                      :readonly="edit"
                      :rules="[(v) => $required(v), (v) => $max($unMask(v), 11), (v) => $min($unMask(v), 11)]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="content.email"
                      label="E-mail*"
                      maxlength="100"
                      counter="100"
                      outlined
                      dense
                      :readonly="edit"
                      :rules="[(v) => $required(v), (v) => $max(v, 100), (v) => $email(v)]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="content.telefone"
                      v-mask="'(##) #####-####'"
                      label="Telefone para Contato*"
                      maxlength="15"
                      outlined
                      dense
                      v-only-number
                      :readonly="edit"
                      :rules="[(v) => $required(v), (v) => $max($unMask(v), 11), (v) => $min($unMask(v), 11)]"
                    ></v-text-field>
                  </v-col>
                  <v-col :cols="content.possuiNomeSocial ? '6' : '12'">
                    <span class="mr-4">Possui nome social?</span>
                    <v-radio-group
                      v-model="content.possuiNomeSocial"
                      class="ml-4"
                      row
                      dense>
                      <v-radio
                        label="Sim"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        label="Não"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6" v-if="content.possuiNomeSocial">
                    <v-text-field
                      v-model="content.nomeSocial"
                      label="Nome Social"
                      outlined
                      dense
                      maxlength="100"
                      counter="100"
                      :rules="[(v) => $required(v)]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div v-if="$usuarioAdministrador">
              <h2 class="mt-4"><v-icon>mdi-account-check</v-icon> Acesso ao Sistema</h2>
              <v-row class="d-flex justify-center mt-2">
                <v-col cols="12">
                  <v-select
                    v-model="content.perfil"
                    label="Perfil de Acesso"
                    outlined
                    dense
                    item-text="nome"
                    item-value="id"
                    :items="form.lists.listPerfis"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <h2 class="mt-4"><v-icon>mdi-account-tie</v-icon> Dados Profissionais</h2>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="6">
                <v-select
                  v-model="content.escolaridade"
                  label="Grau de Escolaridade*"
                  item-text="descricao"
                  item-value="value"
                  outlined
                  dense
                  :items="$opcoesGrauEscolaridade"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.funcao"
                  label="Função no Programa*"
                  item-text="nome"
                  item-value="id"
                  outlined
                  dense
                  :items="form.lists.listFuncoes"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.municipio"
                  label="Município*"
                  item-text="nome"
                  item-value="nome"
                  outlined
                  dense
                  :items="form.lists.listMunicipios"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.lotacao"
                  label="Local de Lotação*"
                  item-text="local"
                  item-value="id"
                  outlined
                  dense
                  :items="form.lists.filteredListLotacoes"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col :cols="content.possuiOutroLocalDeLotacao ? '6' : '12'">
                <span class="mr-4">Possui outro local de lotação?</span>
                <v-radio-group
                  v-model="content.possuiOutroLocalDeLotacao"
                  row
                  dense
                  class="ml-4">
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6"></v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-2"  v-if="content.possuiOutroLocalDeLotacao">
              <v-col cols="6">
                <v-autocomplete
                  v-model="content.municipioLotacaoDois"
                  label="Município*"
                  item-text="nome"
                  item-value="nome"
                  outlined
                  dense
                  :items="form.lists.listMunicipiosDois"
                  :rules="[(v) => $required(v)]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="content.lotacaoDois"
                  label="Local de Lotação*"
                  item-text="local"
                  item-value="id"
                  outlined
                  dense
                  :items="form.lists.filteredListLotacoesDois"
                  :disabled="!content.municipioLotacaoDois"
                  :rules="rulesLotacaoDois"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <h2 class="mt-4"><v-icon>mdi-home</v-icon> Endereço Residencial</h2>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="6">
                <v-text-field
                  v-model="content.endereco.cep"
                  v-mask="'#####-###'"
                  label="CEP*"
                  outlined
                  dense
                  v-only-number
                  @focusout="!edit && buscarEnderecoPorCep($event)"
                  :readonly="edit"
                  :rules="[(v) => $required(v), (v) => $max($unMask(v), 8), (v) => $min($unMask(v), 8)]"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="content.endereco.logradouro"
                  label="Logradouro*"
                  maxlength="100"
                  counter="100"
                  outlined
                  dense
                  :readonly="edit"
                  :rules="[(v) => $required(v), (v) => $max(v, 100)]"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="content.endereco.bairro"
                  label="Bairro*"
                  maxlength="100"
                  counter="100"
                  outlined
                  dense
                  :readonly="edit"
                  :rules="[(v) => $required(v), (v) => $max(v, 100)]"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="content.endereco.uf"
                  label="UF*"
                  item-text="value"
                  item-value="value"
                  outlined
                  dense
                  :items="$opcoesUFS"
                  :readonly="edit"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="content.endereco.municipio"
                  label="Município*"
                  item-text="nome"
                  item-value="nome"
                  outlined
                  dense
                  :readonly="edit"
                  :items="form.lists.listMunicipios"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="content.endereco.numero"
                  label="Número*"
                  maxlength="10"
                  counter="10"
                  outlined
                  dense
                  v-only-number
                  :readonly="edit"
                  :rules="[(v) => $required(v), (v) => $max(v, 10)]"
                ></v-text-field>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="content.endereco.complemento"
                  :readonly="edit"
                  label="Complemento"
                  maxlength="100"
                  counter="100"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <div class="alert-message d-flex align-center mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Profissional } from '~/commons/classes/profissional';
import FuncaoService from '~/services/funcao.service';
import PreLoginService from '~/services/pre-login.service';
import ProfissionalService from '~/services/profissional.service';
import PerfilService from '~/services/perfil.service';
import LotacaoService from '~/services/lotacao.service';
import PermissaoMixin from "~/mixins/permissao.mixin";

export default {
  props: new DialogProps(Profissional),
  mixins: [
    FuncaoService,
    PreLoginService,
    ProfissionalService,
    PerfilService,
    LotacaoService,
    PermissaoMixin,
  ],
  data: () => ({
    form: {
      lists: {
        listFuncoes: [],
        listPerfis: [],
        listMunicipios: [],
        listMunicipiosDois: [],
        listLotacoes: [],
        filteredListLotacoes: [],
        filteredListLotacoesDois: [],
      },
    }
  }),
  computed: {
    rulesLotacaoDois() {
      // Retorna a regra de validação apenas se municipioLotacaoDois estiver preenchido
      return this.content.municipioLotacaoDois ? [(v) => this.$required(v)] : [];
    },
    imgURL() {
      return this.content.foto ? URL.createObjectURL(this.content.foto) : "/img/picto-icon-user.png";
    },
  },
  watch: {
    "content.municipio": function(value) {
      if (value) {
        this.form.lists.filteredListLotacoes = this.form.lists.listLotacoes.filter((lotacao) => lotacao.municipio === value);
        this.content.lotacao = this.form.lists.filteredListLotacoes.filter(lotacao => lotacao.id === this.content.lotacao)[0] ?? null;
      } else {
        this.form.lists.filteredListLotacoes = this.form.lists.listLotacoes;
      }
    },
    "content.municipioLotacaoDois": function (value) {
      if (!value) {
        this.content.lotacaoDois = null;
        this.form.lists.filteredListLotacoesDois = [];
      } else {
        this.form.lists.filteredListLotacoesDois = this.form.lists.listLotacoes.filter(
          (lotacao) => lotacao.municipio === value
        );
      }
    },
    'content.possuiNomeSocial': function (newValue) {
      if (!newValue) {
        this.content.nomeSocial = null;
      }
    },
    'content.possuiOutroLocalDeLotacao': function (newValue) {
      if (!newValue) {
        this.content.lotacaoDois = null;
      }
    },
  },
  methods: {
    onButtonClick() {
      if (this.content.foto) {
        return this.removerFoto();
      }
      window.addEventListener("focus", () => { this.isSelecting = false; }, { once: true });
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      const file = e.target.files[0];
      const size = 5;
      if (this.validarTamanhoMinimoArquivo(file)) {
        return this.$notifyError(`Selecione um arquivo com um tamanho maior que 0KB!`);
      }
      if (!this.validarFormatoDoArquivo(file) || this.validarTamanhoArquivo(file, size)) {
        return this.$notifyError(`A imagem anexada precisa ter até ${size}MB e ser do tipo JPG, JPEG ou PNG.`);
      }
      this.content.foto = file;
    },
    /**
     * Valida o formato do arquivo e retorna TRUE caso o arquivo seja do tipo JPG, JPEG ou PNG.
     * @param file Arquivo do tipo File a ser validado.
     */
    validarFormatoDoArquivo(file) {
      return ['image/jpeg', 'image/png', 'image/jpg'].includes(file?.type);
    },
    /**
     * Valida o tamanho do arquivo e retorna TRUE caso o arquivo seja maior que o parametro tamanhoMaximo.
     * @param file Arquivo do tipo File a ser validado.
     * @param tamanhoMaximo Tamanho máximo do arquivo em MB.
     */
    validarTamanhoArquivo(file, tamanhoMaximo) {
      return tamanhoMaximo * 1024 * 1024 <= file?.size;
    },
    /**
     * Valida o tamanho do arquivo e retorna FALSE caso o arquivo possua um tamanho negativo ou zero.
     * @param file Arquivo do tipo File a ser validado.
     */
    validarTamanhoMinimoArquivo(file) {
      return !file?.size;
    },
    removerFoto() {
      this.content.foto = null;
    },
    salvar() {
      const save = () => {
        if (this.content.lotacao && this.content.lotacaoDois && this.content.lotacao === this.content.lotacaoDois) {
          this.$notifyError("O mesmo local de lotação foi selecionado nas duas opções. É necessário escolher locais distintos.");
          return;
        }
        const text = this.edit
          ? "Deseja editar o registro?"
          : `Atenção: uma vez enviados, os dados pessoais e de endereço não podem ser alterados. Deseja cadastrar o registro?`;
        return this.$swal({
          text,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const profissional = new Profissional(this.content).formatParaEnviar();
          const formDataSalvarProfissional = new FormData();
          formDataSalvarProfissional.append("comandoProfissional", JSON.stringify(profissional));
          formDataSalvarProfissional.append("fotoProfissional", profissional.foto);
          return this.edit
            ? this.$editarProfissional(formDataSalvarProfissional, profissional.id)
            : this.$cadastrarProfissional(formDataSalvarProfissional);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    buscarEnderecoPorCep() {
      const cepSemMascara = this.content.endereco.cep?.replace(/\D/g, "");
      if (!this.$validarTamanhoCEP(cepSemMascara)) {
        return this.$notifyError("Formato do CEP inválido. Verifique os dados inseridos e tente novamente.");
      }
      this.$obterCEP({ params: { cep: cepSemMascara } }).then((response) => {
        const endereco = response.data.endereco;
        if (!response.data.sucesso || !(endereco?.cep && endereco?.logradouro && endereco?.bairro && endereco?.municipio && endereco?.uf)) {
          return this.$notifyError("Não encontramos o CEP informado. Por favor, preencha os campos de endereço manualmente.");
        }
        this.preencherEndereco(endereco);
      }).catch(() => {
        this.$notifyWarning("Não encontramos o CEP informado. Por favor, preencha os campos de endereço manualmente.");
      });
    },
    preencherEndereco({ cep, logradouro, bairro, municipio, uf }) {
      this.content.endereco = {
        cep: this.$formatarCep(cep),
        logradouro,
        bairro,
        municipio: municipio.nome,
        uf: uf.nome,
      };
    },
    buscarFuncoes() {
      this.$buscarFuncoes({ params: { ativo: true } }).then(({ data }) => (this.form.lists.listFuncoes = data.funcoes));
    },
    buscarMunicipios() {
      this.$obterMunicipios().then(({ data }) => {
        this.form.lists.listMunicipios = data.lista;
        this.form.lists.listMunicipiosDois = data.lista;
      });
    },
    buscarLotacoes(value) {
      this.$buscarLotacoes({ params: { municipioId: value } }).then(({ data }) => (this.form.lists.listLotacoes = data.resposta));
    },
    buscarPerfis() {
      this.$buscarPerfis({ params: { ativo: true } }).then(({ data }) => (this.form.lists.listPerfis = data.resposta));
    },
  },
  mounted() {
    this.buscarFuncoes();
    this.buscarMunicipios();
    if (this.$isUserAdmin()) {
      this.buscarPerfis();
    }
    this.buscarLotacoes();
  },
};
</script>
<style scoped lang="scss">
.img {
  border-radius: 2em;
}
h2 {
  font-size: medium;
}
.btn-image {
  position: absolute;
  left: 8.3%;
  top: 28%;
  z-index: 1;
  &.admin {
    top: 25%;
  }
}
</style>
